import React, { useState} from 'react';
import styles from './Job.module.css';
import Section from '../components/Section/Section';
//import { Fade } from "react-awesome-reveal";
import JobHeader from './JobHeader';
import JobFilters from './JobFilters';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import ExportCSV from './ExportCSV';
import { toDateInputValue } from '../utils/dateUtils';

const JobView = (props) => {
    const {
      job,
      hideDueDateCalendar,
      deleteJob,
      showEditJob,
      uniquePoles,
      handlePoleFilterSelect,
      filteredPole,
      uniqueLines,
      handleLineFilterSelect,
      filteredLine,
      statuses,
      handleStatusFilterSelect,
      filteredStatus,
      filteredTickets,
      toggleCreateTicket,
      handleBack,
      sortBy,
      sort_dir,
      sort_col,
      //toggleCreateTask,
      xlsUpload,
      //handleCSVUpload,
      handleuploadSpreadsheet
      
    } = props;
    const [tickets, setTickets] = useState([]);
    const [filterText, setFilterText] = useState('');
    
 
  
const handleDeleteTicket = (id) => {
  const confirmed = window.confirm('Are you sure you want to delete this ticket?');
  if (confirmed) {
    // TODO: Implement delete ticket logic
    console.log(`Deleting ticket with ID ${id}`);
    const updatedTickets = tickets.filter(ticket => ticket.id !== id);
    setTickets(updatedTickets);
  }
};

    
    
    return (
        <div className="container-fluid px-0 section" onClick={hideDueDateCalendar}>

        {/* section Page Header */}
        <JobHeader 
            showEditJob={showEditJob}
            deleteJob={deleteJob}
            job={job}
        />
        {/* section - Tickets */}
        <Section>
            <div className="col pt-5">
                <p className={styles.sectionTitle}>Tickets</p>
            </div>
        </Section>

        {/* section - Filters */}
        <JobFilters 
            uniquePoles={uniquePoles}
            handlePoleFilterSelect={handlePoleFilterSelect}
            filteredPole={filteredPole}
            uniqueLines={uniqueLines}
            handleLineFilterSelect={handleLineFilterSelect}
            filteredLine={filteredLine}
            statuses={statuses}
            handleStatusFilterSelect={handleStatusFilterSelect}
            filteredStatus={filteredStatus}
        />
        
        
        {/* <Fade when={filteredTickets}> */}
          <Section>
            <div className="col">
              <div className="detail-section ticket-table-wrapper respTable" hidden={filteredTickets === undefined || filteredTickets.length<1} >
                <Table className="table table-striped">
                  <Thead>
                    <Tr>
                      
                      <Th scope="col" onClick={() => sortBy('pole_name')}><label>Pole</label><div className={(sort_dir === "asc" ? "sort-asc" : "sort-desc") + (sort_col === "pole_name" ? "" : ' hidden') + ' sort-icon'} alt="Sort Direction"></div></Th>


                      <Th scope="col" onClick={() => sortBy('line_name')}><label>Line</label> <div className={(sort_dir==="asc"? "sort-asc" : "sort-desc") + (sort_col === "line_name" ? "" : ' hidden') + ' sort-icon'} alt="Sort Direction"></div></Th>
                      {/* <Th scope="col">Description</Th> */}
                      <Th scope="col" onClick={() => sortBy('assigned_to_name')}><label>WF Crew</label> <div className={(sort_dir==="asc"? "sort-asc" : "sort-desc") + (sort_col === "assigned_to_name" ? "" : ' hidden') + ' sort-icon'} alt="Sort Direction"></div></Th>
                      <Th scope="col" onClick={() => sortBy('pole_lat')}><label>GPS</label> <div className={(sort_dir==="asc"? "sort-asc" : "sort-desc") + (sort_col === "pole_lat" ? "" : ' hidden') + ' sort-icon'} alt="Sort Direction"></div></Th>
                      <Th scope="col" onClick={() => sortBy('street_address')}><label>Address</label> <div className={(sort_dir==="asc"? "sort-asc" : "sort-desc") + (sort_col === "street_address" ? "" : ' hidden') + ' sort-icon'} alt="Sort Direction"></div></Th>
                      <Th scope="col" onClick={() => sortBy('dig_safe_required')} className='text-center'><label>Digsafe</label> <div className={(sort_dir==="asc"? "sort-asc" : "sort-desc") + (sort_col === "dig_safe_required" ? "" : ' hidden') + ' sort-icon'} alt="Sort Direction"></div></Th>
                      <Th scope="col" onClick={() => sortBy('nra_required')} className='text-center'><label>NRA/DNR</label> <div className={(sort_dir==="asc"? "sort-asc" : "sort-desc") + (sort_col === "nra_required" ? "" : ' hidden') + ' sort-icon'} alt="Sort Direction"></div></Th>
                      <Th scope="col" onClick={() => sortBy('status')} className='text-center'><label>Status</label> <div className={(sort_dir==="asc"? "sort-asc" : "sort-desc") + (sort_col === "status" ? "" : ' hidden') + ' sort-icon'} alt="Sort Direction"></div></Th>
                      <Th scope="col" onClick={() => sortBy('created_date')} ><label>Date Added</label><div className={(sort_dir==="asc"? "sort-asc" : "sort-desc") + (sort_col === "created_date" ? "" : ' hidden') + ' sort-icon'} alt="Sort Direction"></div></Th>
                      <Th scope="col" onClick={() => sortBy('actual_completion_date')} ><label>Date Completed</label><div className={(sort_dir==="asc"? "sort-asc" : "sort-desc") + (sort_col === "actual_completion_date" ? "" : ' hidden') + ' sort-icon'} alt="Sort Direction"></div></Th>
                      <Th scope="col" onClick={() => sortBy('due_date')}><label>Due Date</label><div className={(sort_dir === "asc" ? "sort-asc" : "sort-desc") + (sort_col === "due_date" ? "" : ' hidden') + ' sort-icon'} alt="Sort Direction"></div></Th>
                      <Th></Th>

                      
                    </Tr>
                  </Thead>
                  <Tbody>
                    {
                        
                      (filteredTickets && filteredTickets
                      .map((ticket) => {
                        return (
                          <Tr key={ticket.id} className="clickable-row" data-ticket_id={ticket.id} onClick={toggleCreateTicket}>
                            <Td data-ticket_id={ticket.id}>{ticket.pole_name}</Td>
                            <Td data-ticket_id={ticket.id}>{ticket.line_name}</Td>
                            {/* <Td data-ticket_id={ticket.id}>{ticket.description}</Td> */}
                            <Td data-ticket_id={ticket.id}>{ticket.assigned_to_name ? ticket.assigned_to_name : "Unassigned"}</Td>
                            <Td data-ticket_id={ticket.id}>{(ticket.geo_lon && ticket.geo_lat) ? <div className='pin-image'></div> :  <br></br>}</Td>
                            <Td data-ticket_id={ticket.id}>{ticket?.pole?.street_address}</Td>
                            <Td data-ticket_id={ticket.id} className='text-center'><img src={ticket.dig_safe_required ? (ticket.dig_safe_url ? 'images/green_circle.png' : 'images/red_circle.png') : 'images/grey_circle.png'} alt=''></img></Td>
                            <Td data-ticket_id={ticket.id} className='text-center'><img src={ticket.nra_required ? (ticket.nra_url ? 'images/green_circle.png' : 'images/red_circle.png') : 'images/grey_circle.png'} alt=''></img></Td>
                            <Td data-ticket_id={ticket.id} className='text-center'>{ticket.status}</Td>
                            <Td data-ticket_id={ticket.id}>{ticket.created_date ? new Intl.DateTimeFormat("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "2-digit"
                            }).format(new Date(ticket.created_date)) : ''}</Td>
                            <Td data-ticket_id={ticket.id}>{ticket.actual_completion_date ? new Intl.DateTimeFormat("en-US", {
                              dateStyle: "short",
                              timeStyle: "short",
                            }).format(new Date(ticket.actual_completion_date)) : ''}</Td>
                              <Td data-testid="due-date-cell">
                                {
                                  (() => {
                                    const rawDate = ticket.due_date;
                                    if (!rawDate) return '';
                                    const d = new Date(rawDate);
                                    if (isNaN(d)) return '';
                                    return d.toLocaleDateString('en-US'); // MM/DD/YYYY
                                  })()
                                }
                              </Td>
                            <Td data-ticket_id={ticket.id}></Td>
                            
           
                          </Tr>
                        )
                      }))
                    }
                  </Tbody>
                </Table>
              </div>
              
            </div>
          </Section>
        {/* </Fade> */}
        
        {/* section - Btn Action */}
        <Section newClass="buttonAction">
         
          <div className="col">
            <div className="btn-action d-flex flex-column-reverse flex-sm-row">
              <button type="button" className="btn btn-t mr-sm-auto text-center" onClick={handleBack} style={{marginRight: '15px'}}>Back</button>
              
              
              {/* <button
                type="button"
                className={`btn btn-primary d-flex text-center text-white ${styles.btnIcon}`}
                onClick={toggleCreateTask}
                style={{marginRight: '15px'}}
              >
                <div
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 4H11V7L7 7V11H4V7L0 7V4.04102H4V0H7V4Z"
                    fill="white" />
                </svg>
                <span>Create Task</span>
              </button> */}
              <button
                type="button"
                className={`btn btn-primary d-flex align-items-center mb-4 mb-sm-0 text-white`}
                onClick={toggleCreateTicket}
              >
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 4H11V7L7 7V11H4V7L0 7V4.04102H4V0H7V4Z"
                    fill="white" />
                </svg>
                <span>Create Ticket</span>
              </button>
              
              <div style={{display: 'none'}}>
                  <input type="file" ref={xlsUpload} onChange={handleuploadSpreadsheet}/>
              </div>
            </div>

            {/* <div className="btn-action d-flex justify-content-between align-right">
              <div className="left">
                <button type="button" className="btn btn-lw btn-mw150 text-center" onClick={()=> {this.props.history.replace('/jobs')}}>{this.state.jobId?'Close': 'Cancel'}</button>
                <button type="button" className="btn btn-mw150 btn-danger text-center">Delete</button>
              </div>
            </div> */}
          </div>
        </Section>
        </div>
    );
  };

  export default JobView;